import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/share';

@Injectable()
export class LoginAgainService {

  public status: Subject<any> = new Subject<any>();
  private _open: any;

  constructor() { }

  public get open(): any {
    return this._open;
  }

  public set open(v: any) {
    this._open = v;
    this.status.next(v);
  }

  public isOpen(open : any){
    this.open = open;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/login-again.service.ts